<template>
    <div>
        <div class="btn-instruction" @click="modal_show = true">
            <i class="fa fa-info"></i>
            {{ instr_content.title }}
        </div>


        <!-- Modal: Show Log Detail -->
        <b-modal scrollable size="lg" ref="modal"
                v-model="modal_show"
                header-bg-variant="primary"
                hide-header-close hide-footer>
            
            <!-- header -->
            <div slot="modal-header">
                <i class="fa fa-graduation-cap"></i>{{ $t('menu.little_doctor_agri') }}
            </div>
            
            <!-- body -->
            <div>
                <b-row class="justify-content-center">

                    <b-col md=11>
                        <div class="instruction-title">{{ instr_content.title }}</div>
                        <div class="instruction-context">
                            {{ instr_content.content[0] }}
                        </div>
                        <div class="instruction-context">
                            {{ instr_content.content[1] }}
                        </div>
                    </b-col>

                    <b-col md="7" lg=8>
                        <div class="instruction-img">
                            <b-img :src="$config.getAssetsURL('img/instr/report_instructions_KChart_1.png')" fluid alt="report_instructions_KChart_1" />
                        </div>
                    </b-col>
                    <b-col md="5" lg=4 align-self="end">
                        <ul>
                            <li>{{ instr_content.content[2] }}</li>
                            <li>{{ instr_content.content[3] }}</li>
                            <li>{{ instr_content.content[4] }}</li>
                            <li>{{ instr_content.content[5] }}</li>
                        </ul>
                    </b-col>

                    <b-col md="11">
                        <div class="instruction-context">
                            <strong>{{ instr_content.content[6] }}</strong><br>
                            {{ instr_content.content[7] }}
                        </div>
                        <div class="instruction-context">
                            <strong>{{ instr_content.content[8] }}</strong><br>
                            {{ instr_content.content[9] }}
                        </div>
                    </b-col>

                    <b-col md="8">
                        <div class="instruction-img">
                            <b-img :src="$config.getAssetsURL('img/instr/report_instructions_KChart_2.png')" fluid alt="report_instructions_KChart_2" />
                        </div>
                    </b-col>

                    <b-col md="11">
                        <div class="instruction-context">
                            <strong>{{ instr_content.content[10] }}</strong>
                        </div>
                        <div class="instruction-context">
                            <i class="fa fa-caret-right"></i>
                            {{ instr_content.content[11] }}
                        </div>
                        <div class="instruction-context">
                            <i class="fa fa-caret-right"></i>
                            {{ instr_content.content[12] }}
                        </div>
                        <div class="instruction-context">
                            <i class="fa fa-caret-right"></i>
                            {{ instr_content.content[13] }}
                        </div>
                    </b-col>

                </b-row>
                
            </div>

            <!-- footer -->
            <div class="modal-footer-block text-center">
                
                <b-button variant="secondary" class="btn btn-upload"
                        @click.prevent="modal_show = false">
                    <i class="fa fa-close"></i> {{ $t('menu.close') }}
                </b-button>

            </div>

        </b-modal>



        
    </div>
</template>

<script>
import { mapState }     from 'vuex'

export default {
    data () {
        return {
            instruction_title: 'K 線圖怎麼看 ?',
            
            // modal
            modal_show: false,
        }
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

        instr_content ()
        {
            if ( this.language == 'zh-Hant-TW' )
            {
                return {
                    title: 'K 線圖怎麼看 ?',
                    content: [
                        'K 線圖，又稱蠟燭圖，由一天內 ( 凌晨 0 點到 23 點 ) 的起始值 ( Start )、最大值 ( Max )、最小值 ( Min )、結束值 ( End ) 所繪製。',
                        '粗方塊上下界為當日起始值及結束值，線條上下點為當日最大值及最小值，可迅速看出每日測值上漲及下跌變化。',

                        'Start： 起始值',
                        'End： 結束值',
                        'Max： 最大值',
                        'Min： 最小值',

                        'Red candle 紅色蠟燭 (上圖左邊)',
                        '若當日結束值大於起始值，參數上漲，色塊為紅色。',
                        'Green candle 綠色蠟燭 (上圖右邊)',
                        '若當日結束值小於起始值，參數下跌，色塊為綠色。',
                        'Example 1 範例一 (上圖)',
                        '12/05 當天應有降不少雨或灌溉不少量，使土壤含水量大增超過 5%。',
                        '而隔天 12/06 可推測雨勢或灌水稍歇，因結束值略小於最高值，可推測降水並未持續到午夜。',
                        '12/06 後緩慢下降 ( 顏色為綠色方塊 )，無線條突出表示：最大值 = 起始值、最小值 = 結束值。',
                    ],
                }
            }
            else
            {
                return {
                    title: 'What is Candlestick chart ?',
                    content: [
                        '“Candlestick chart” is composed of “candlestick”. Each “candlestick” represents 4 values of one day, open value ( the first value of a day ), maximum, minimum, and close value ( the last value of a day ).',
                        'The bar represents open value and close value, while the string represents maximum and minimum. With the “Candlestick chart”, it’s very easy to realize the ups and downs of data difference between days.',
                        
                        'Start： open value',
                        'End： close value',
                        'Max： maximum',
                        'Min： minimum',

                        'Red candle ( above left )',
                        'If the close value is bigger than the open value, which means the value goes up,  the bar will be red.',
                        'Green candle ( above right )',
                        'If the close value is smaller than the open value, which means the value goes down, the bar will be green.',
                        'Example 1 ( above )',
                        'On Dec 15th, the soil moisture raises more 5 %, which may because of the rainy day or watering.',
                        'On Dec 16th, because the close value is smaller than the maximum. The situation of rainy or watering may not last until midnight.',
                        'After Dec 16th, the soil moisture value keeps decrease (the bars are all green). No string outside the bar represents that the maximum is equal to the open value and the minimum is equal to the close value.',
                    ],
                }
            }
        },

    },
}
</script>

<style lang="scss" scoped>

ul {
    padding-left: 15px;
}

.modal-footer-block
{
    margin: 15px 0px;
}

</style>